<section class="manifest-preview" aria-labelledby="configured-function-preview-title">
  <div class="manifest-heading">
    <div>
      <h3 id="configured-function-preview-title">Configured-function eligibility preview</h3>
      <p>
        Read-only analysis of the saved assistant, function, and product-feed configuration. A later per-turn provider
        request can still omit eligible tools because of tool budget or mutation policy. Loading this preview never
        executes a function.
      </p>
    </div>
    <button mat-stroked-button type="button" (click)="refresh()" [disabled]="isLoading || !assistantId">
      <mat-icon>refresh</mat-icon>
      Refresh saved preview
    </button>
  </div>

  @if (isLoading) {
    <div class="manifest-state" role="status">
      <mat-spinner diameter="24"></mat-spinner>
      Loading saved configuration preview…
    </div>
  } @else if (loadFailed) {
    <div class="manifest-state manifest-error" role="alert">
      Preview unavailable. Retry after confirming the saved assistant configuration can be loaded.
    </div>
  } @else if (manifest && manifest.entries.length === 0) {
    <div class="manifest-state">No configured functions exist in the saved client configuration.</div>
  } @else if (manifest) {
    <div class="manifest-entries">
      @for (entry of manifest.entries; track entryKey(entry)) {
        <article class="manifest-entry" [class.manifest-entry-hidden]="!entry.normalReachable">
          <div class="entry-heading">
            <div>
              <h4>{{ entry.resolvedToolName || 'Unnamed configured function' }}</h4>
              <span>{{ entry.functionType }} · version {{ entry.version }} · {{ selectionLabel(entry.selection) }}</span>
            </div>
            <div class="reachability" aria-label="Saved configuration reachability">
              <span [class.reachable]="entry.normalReachable">
                Normal: {{ entry.normalReachable ? 'eligible' : 'excluded' }}
              </span>
              <span [class.reachable]="entry.realtimeReachable">
                Realtime: {{ entry.realtimeReachable ? 'eligible' : 'excluded' }}
              </span>
            </div>
          </div>

          @if (entry.hiddenReasons.length || entry.unreachableReasons.length || entry.migrationReasons.length) {
            <div class="reason-groups">
              @for (reason of entry.hiddenReasons; track reason) {
                <span class="reason">Hidden: {{ reason }}</span>
              }
              @for (reason of entry.unreachableReasons; track reason) {
                <span class="reason reason-error">Unavailable: {{ reason }}</span>
              }
              @for (reason of entry.migrationReasons; track reason) {
                <span class="reason reason-warning">Migration: {{ reason }}</span>
              }
            </div>
          }

          @if (entry.conflicts.length) {
            <div class="conflicts" role="status">
              @for (conflict of entry.conflicts; track $index) {
                <span>{{ conflictLabel(conflict.kind) }}</span>
              }
            </div>
          }

          <details>
            <summary>Sanitized configured definition</summary>
            <p>{{ entry.providerVisibleDescription || 'No description configured.' }}</p>
            <pre>{{ entry.providerVisibleInputSchema || '{}' }}</pre>
            <small>This structural projection is not the exact final per-turn provider payload.</small>
          </details>
        </article>
      }
    </div>
  }
</section>
